import React from 'react';

import { colorsPalette } from '../../theme';

const FilterIcon = (props) => {
  const color = props?.color;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M23.9306 1.3561C23.8105 1.10142 23.5542 0.938965 23.2727 0.938965H0.727432C0.445884 0.938965 0.189648 1.10142 0.0694836 1.3561C-0.0505843 1.61078 -0.012954 1.91183 0.166178 2.12907L8.83289 12.6407V22.3335C8.83289 22.5851 8.96294 22.8189 9.1767 22.9515C9.29386 23.0242 9.42683 23.0608 9.56028 23.0608C9.67055 23.0608 9.78121 23.0357 9.88324 22.9852L14.7527 20.5717C15.0001 20.4491 15.1566 20.1971 15.157 19.9209L15.1665 12.641L23.8337 2.12898C24.0129 1.91182 24.0507 1.61069 23.9306 1.3561ZM13.8784 11.9167C13.7712 12.0467 13.7124 12.2099 13.7122 12.3785L13.7029 19.4684L10.2878 21.1611V12.3795C10.2878 12.2106 10.2291 12.047 10.1216 11.9167L2.26989 2.39365H21.7301L13.8784 11.9167Z"
        fill={color ? color : colorsPalette.white}
      />
    </svg>
  );
};

export default FilterIcon;
